import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '../_common/carousel';
import ProductCard, { itemType } from './product-card';

const slickSettings = {
  arrows: true,
  infinite: true,
  speed: 300,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3, slidesToScroll: 3, dots: true },
    },
    {
      breakpoint: 992,
      settings: { slidesToShow: 3, slidesToScroll: 3, arrows: false, dots: true },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2, slidesToScroll: 2, arrows: false, dots: true },
    },
    {
      breakpoint: 576,
      settings: { slidesToShow: 2, slidesToScroll: 2, arrows: false, dots: true },
    },
  ],
};

const ProductCarousel = ({ id, title, items, className }) => (
  <div
    className={classNames(
      'recent-products-list col-lg-9 col-12 mt-3 px-0',
      className,
    )}>
    {title && <h2 className="h3">{title}</h2>}
    <Carousel id={id} slickSettings={slickSettings} responseMessage={null}>
      {items.map((item) => (
        <ProductCard key={item.key} item={item} />
      ))}
    </Carousel>
  </div>
);

ProductCarousel.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(itemType).isRequired,
  className: PropTypes.string,
};

export default ProductCarousel;
